import { render } from "./typingHeader.vue?vue&type=template&id=f4a99e14&ts=true"
import script from "./typingHeader.vue?vue&type=script&lang=ts"
export * from "./typingHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__